import { render, staticRenderFns } from "./NumberWidget.vue?vue&type=template&id=250ff64f"
import script from "./NumberWidget.vue?vue&type=script&lang=js"
export * from "./NumberWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports